import classNames from "classnames";
import type { ReactNode } from "react";
import { BaseButton } from "../../../../components/Button/BaseButton.tsx";
import { Tooltip } from "../../../../components/Tooltip/Tooltip.tsx";

export const ToolbarActionItem = ({
  children,
  isActive,
  title,
  tooltipContent,
  onClick,
  isBeta = false,
}: {
  children: ReactNode;
  isActive: boolean;
  title: string;
  tooltipContent?: ReactNode;
  onClick: () => void;
  isBeta?: boolean;
}) => (
  <MenuSelectionTooltip tooltipContent={tooltipContent}>
    <BaseButton
      onClick={onClick}
      className="flex-col-center group p-200 gap-100 w-full"
    >
      <div
        className={classNames(
          "p-200 rounded-150",
          isActive
            ? "bg-surface-primary-active"
            : "group-hover:bg-surface-primary-hover",
        )}
      >
        {children}
      </div>
      <div className="flex-col items-center text-primary">
        <div className="label-sm-semibold whitespace-nowrap">{title}</div>
        {isBeta && (
          <div className="text-emphasis-secondary label-md-semibold px-150 rounded-full bg-blue-100">
            Beta
          </div>
        )}
      </div>
    </BaseButton>
  </MenuSelectionTooltip>
);

const MenuSelectionTooltip = ({
  children,
  tooltipContent,
}: {
  children: ReactNode;
  tooltipContent?: ReactNode;
}) => (
  <Tooltip
    side="right"
    align="start"
    arrowDisplayed
    disableHoverableContent
    delayDuration={500}
    content={tooltipContent}
    // FIXME: Remove those attributes from the Tooltip component
    className="!bg-surface-inverse-rest !rounded-200 !text-inverse-primary"
  >
    {children}
  </Tooltip>
);
